import React from 'react';
import Classnames from 'classnames';
import { browserHistory } from 'react-router';
import ChecklistItemMarketing from './checklist-item-marketing';
import SignpostItemMarketing from './signpost-item-marketing';

export default class ChecklistSectionMarketing extends React.Component {

  constructor() {
    super();
    this.state = { closed: false }
    this.hasHighlight = false;
    this.requestRegisterModal = this.requestRegisterModal.bind(this);
    this.escapeRegex = this.escapeRegex.bind(this);
  }

  componentDidMount() {
    let closed = false;
    let inactive = typeof (this.props.list) === 'undefined' || this.props.list.length === 0;

    closed = !this.props.signposts && !(this.props.query && this.props.query['highlight-text'] && this.hasHighlight) && this.props.id !== 0;
    return this.setState({ closed, inactive });
  }

  escapeRegex(s) {
    return s.replace(/[-/\\^$*+?.()|[\]{}]/g, '\\$&');
  };

  highlightText(text) {
    if (this.props.query && this.props.query['highlight-text']) {
      let term = this.escapeRegex(this.props.query['highlight-text']);
      let regex = new RegExp(`(${term})`, 'i');

      if (text.toLowerCase().match(regex)) {
        if (!this.hasHighlight) {
          this.hasHighlight = true;
        }
        return this.decorateText(text, regex);
      }
    }
    return text;
  }

  decorateText(text, regex) {
    return text.replace(regex, (match) => {
      return `<mark>${match}</mark>`;
    })
  }

  requestRegisterModal() {
    browserHistory.replace(`${window.location.pathname}?modal=register&restricted=1`)
  }

  generateTitle(titleObj) {
    let title = this.highlightText(titleObj.text);
    let footnotes = titleObj.footnotes;
    let parsed_footnotes = '';

    if (footnotes && footnotes.length) {
      parsed_footnotes = footnotes.map((footnote, i, array) => {
        let lastItemIndex = array.length - 1;
        let comma = i === lastItemIndex ? '' : ', ';

        return `<a class="footnote-link" href="${window.location.pathname}#s${footnote}"><sup>${footnote}${comma}</sup></a>`;
      }).join("");
    }

    let html = `${title}${parsed_footnotes}`

    return (
      <div className="text-content" dangerouslySetInnerHTML={{ __html: html }}></div>
    )
  }

  generateLists(list) {
    return list.map((item, index) => {
      let title = this.generateTitle(item.title);
      let { sub_list } = item;
      let innerList = (sub_list) ? this.genereteSubList(sub_list) : '';
      return (
        <ChecklistItemMarketing key={index} title={title} text={item.title.text} innerList={innerList}>
        </ChecklistItemMarketing>
      )
    })
  }

  genereteSubList(list) {
    if (!list) {
      return;
    }

    return list.map((item, index) => {
      let title = this.generateTitle(item.title);
      return (
        <ul className="fa-ul" key={index}>
          <ChecklistItemMarketing sublist={true} title={title} text={item.title.text}></ChecklistItemMarketing>
        </ul>
      )
    })
  }

  generateSignPostList(list) {
    return list.data.map((signpost, i) => {
      let title = this.generateTitle({ text: signpost.title });
      return (
        <SignpostItemMarketing {...signpost} title={title} id={'s' + (i + 1)} key={'s' + (i + 1)}></SignpostItemMarketing>
      );
    })
  }

  handleClick(e) {
    // if the click is for the footnote links then don't
    // toggle the section.
    if (['footnote-link', 'sup'].indexOf(e.target.localName) > -1) {
      e.stopPropagation();
      return;
    }

    if (this.state.inactive) {
      return this.requestRegisterModal();
    }

    this.refs.checklist.classList.toggle('checklist-closed');
    this.setState({ closed: !this.state.closed })
  }

  componentDidCatch(error, info) {
    // You can also log the error to an error reporting service
    console.log(error, info);
  }

  render() {
    let classes = Classnames({
      "checklist-section": true, // We'll scope these classes to marketing design CSS
      "signposts": !!this.props.signposts,
      "checklist-closed": this.state.closed,
      "inactive": this.state.inactive,
      // subscriber-only content; named in the checklist's paywall JSON-LD (server/seo/checklist.js)
      "locked-section": this.state.inactive && !this.props.signposts
    });

    let chevron = (
      <svg
        className={`section-chevron ${this.state.closed ? 'closed' : ''}`}
        width="20" height="20" viewBox="0 0 24 24" fill="none"
        stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"
      >
        <polyline points="18 15 12 9 6 15"></polyline>
      </svg>
    );

    let section_title = this.generateTitle(this.props.title);
    let section_list = (this.props.signposts) ? (<ol>{this.generateSignPostList(this.props.list)}</ol>) : (<ul className="fa-ul">{this.generateLists(this.props.list)}</ul>);

    return (
      <div ref="checklist" className={classes}>
        <header className="checklist-section--header" style={{
          border: 'none'
        }} onClick={this.handleClick.bind(this)}>
          <div className="header-content">
            <h2>{section_title}</h2>
            {!this.state.inactive && chevron}
            {this.state.inactive && <span className="locked-badge">Locked</span>}
          </div>
        </header>
        {!this.state.inactive ?
          <div className="checklist-content-inner">
            {section_list}
          </div>
          : ''}
      </div>
    )
  }
}
